import styled from 'styled-components'

export const StyledSwitchContainer = styled.div`
    display: flex;
    justify-content: space-between;
`
